module.exports = __webpack_public_path__ + "c6f6796d0070566ba93ffce4463888f0.pdf";